export const table = (state) => state.table
export const info = (state) => state.info